/**
 * <p-vorteile-bar data-autorotate="true|false" data-interval="4000">
 * 1:1-Port aus Hyper (assets/vorteile-bar.js).
 * Mobile (< 750px): natives Scroll-Snap-Swipen + Auto-Rotation mit Endlos-Loop.
 * Loop per Klon-Technik: Klon des letzten Items vorn, Klon des ersten hinten; landet der Scroll
 * auf einem Klon, wird ohne Animation auf das echte Gegenstück gesprungen.
 * Desktop: statische Reihe, Klone per CSS ausgeblendet, kein Eingriff.
 */
if (!customElements.get('p-vorteile-bar')) {
  const MOBILE = window.matchMedia('(max-width: 749px)');
  const RESUME_AFTER = 6000; // Auto-Rotation 6 s nach letzter Nutzer-Interaktion fortsetzen

  class PVorteileBar extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-benefits-list]');
      this.items = this.list ? [...this.list.querySelectorAll('[data-benefit]')] : [];
      if (this.items.length < 2) return;

      // Slot-Index inkl. Klonen: 0 = Klon(letztes), 1..N = echte Items, N+1 = Klon(erstes)
      this.index = 1;
      this.paused = false;
      this.buildClones();
      if (MOBILE.matches) this.jumpTo(1);

      this.onResize = () => {
        this.setup();
        if (MOBILE.matches) this.jumpTo(this.index);
      };
      this.onUser = () => {
        this.paused = true;
        clearTimeout(this.resumeTimer);
        this.resumeTimer = setTimeout(() => (this.paused = false), RESUME_AFTER);
      };
      this.onSettle = () => this.settle();
      // Fallback ohne scrollend-Event: „gelandet“ = 120 ms kein scroll-Event mehr
      this.onScroll = () => {
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(this.onSettle, 120);
      };

      window.addEventListener('resize', this.onResize);
      this.list.addEventListener('touchstart', this.onUser, { passive: true });
      this.list.addEventListener('wheel', this.onUser, { passive: true });
      if ('onscrollend' in window) this.list.addEventListener('scrollend', this.onSettle);
      else this.list.addEventListener('scroll', this.onScroll, { passive: true });

      this.setup();
    }

    disconnectedCallback() {
      if (!this.onResize) return;
      clearInterval(this.timer);
      clearTimeout(this.resumeTimer);
      clearTimeout(this.settleTimer);
      window.removeEventListener('resize', this.onResize);
      this.list.removeEventListener('touchstart', this.onUser);
      this.list.removeEventListener('wheel', this.onUser);
      this.list.removeEventListener('scrollend', this.onSettle);
      this.list.removeEventListener('scroll', this.onScroll);
    }

    buildClones() {
      if (this.list.querySelector('.vorteile-bar__item--clone')) return;
      this.list.insertBefore(this.cloneOf(this.items[this.items.length - 1]), this.items[0]);
      this.list.appendChild(this.cloneOf(this.items[0]));
    }

    cloneOf(item) {
      const clone = item.cloneNode(true);
      clone.classList.add('vorteile-bar__item--clone');
      clone.removeAttribute('data-benefit');
      clone.setAttribute('aria-hidden', 'true');
      [...clone.attributes]
        .filter((a) => a.name.startsWith('data-shopify'))
        .forEach((a) => clone.removeAttribute(a.name));
      return clone;
    }

    setup() {
      clearInterval(this.timer);
      if (MOBILE.matches && this.dataset.autorotate === 'true') {
        this.timer = setInterval(() => this.next(), parseInt(this.dataset.interval, 10) || 4000);
      }
    }

    settle() {
      const width = this.list.clientWidth;
      if (!MOBILE.matches || !width) return;
      const pos = Math.round(this.list.scrollLeft / width);
      const n = this.items.length;
      if (pos === 0) this.jumpTo(n);
      else if (pos === n + 1) this.jumpTo(1);
      else this.index = pos;
    }

    jumpTo(slot) {
      const width = this.list.clientWidth;
      if (!width) return;
      const behavior = this.list.style.scrollBehavior;
      this.list.style.scrollBehavior = 'auto';
      this.list.scrollLeft = slot * width;
      this.list.style.scrollBehavior = behavior;
      this.index = slot;
    }

    next() {
      const width = this.list.clientWidth;
      if (this.paused || !width) return;
      // Läuft beim letzten echten Item auf den End-Klon; settle() springt danach unsichtbar auf das erste.
      this.index = Math.min(this.index + 1, this.items.length + 1);
      this.list.scrollTo({ left: this.index * width, behavior: 'smooth' });
    }
  }

  customElements.define('p-vorteile-bar', PVorteileBar);
}
